import { path } from "ramda";
import { put, call } from "redux-saga/effects";

import AuthenActions from "../reducers/AuthenReducer";
import ModalUtil from "../util/modal";
import OrganizationActions from "../reducers/OrganizationReducer";
import UserActions from "../reducers/UserReducer";
import { history } from "../reducers/configureStore";
import ROUTE from "../constants/route";


const loginRequest = function* (api, {
	email, tel, password,
}) {
	try {
		const res = yield call(api.authen, { email, tel, password });
		const data = path(["data"], res);
		const user = path(["data", "user", "data"], res);
        
		if (res.ok && data) {
			yield put(AuthenActions.loginSuccess(data));
			yield put(UserActions.getUserSuccess(user));
			history.push(`/${ROUTE.CORPORATE_LIST}`);

		} else {
			ModalUtil.showError(res); 
			yield put(AuthenActions.loginFailure());
		}
	} catch (e) {
		ModalUtil.showDefaultError();
		yield put(AuthenActions.loginFailure());
	}
};

export { loginRequest };


// WEBPACK FOOTER //
// ./src/sagas/AuthenSaga.js